@if (labelCols != null) {
    <div class="form-group row">
        <div [class]="gridClass">
            <ng-container [ngTemplateOutlet]="checkbox" />
        </div>
    </div>
} @else {
    <ng-container [ngTemplateOutlet]="checkbox" />
}

<ng-template #checkbox>
    <div class="form-check" appCheckboxArea [appCheckboxAreaDisabled]="control.disabled">
        <input
            type="checkbox"
            class="form-check-input"
            id="{{ id }}"
            [attr.aria-describedby]="description ? id + '-description' : null"
            [formControl]="control" />

        <div class="d-flex justify-content-between">
            <label class="form-check-label" for="{{ id }}">{{ label }}</label>
            @if (information) {
                <app-tooltip [popover]="information" />
            }
        </div>

        @if (description) {
            <div id="{{ id }}-description" class="text-muted small">{{ description }}</div>
        }
    </div>
</ng-template>
